module.exports = __webpack_public_path__ + "img/FR27533.89015fb3.png";